import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { truncateText, typographyButton } from './../../core';

export const StyledTabTitle = styled.span`
  ${truncateText};
  ${({ theme }) => typographyButton(theme)};
  ${({ isActive }) =>
    !isActive &&
    css`
      color: ${({ theme }) => theme.color.text.light.secondary.value};
    `};
`;

const TabTitle = ({ customTag, ...other }) => <StyledTabTitle as={customTag} {...other} />;

TabTitle.propTypes = {
  /** Ability to supply a different element instead of the default one */
  customTag: PropTypes.elementType,
  /** If true shows title as selected */
  isActive: PropTypes.bool,
};

TabTitle.defaultProps = {
  customTag: undefined,
  isActive: false,
};

export { TabTitle };
